import { createReducer, on } from '@ngrx/store';

import * as fromRootImpeActions from '@apps/root/store/impersonate/impe.actions';
import * as fromAuthLoginActions from '@apps/auth/store/login/login.actions';
import * as fromAuthProfileActions from '@apps/auth/store/profile/profile.actions';
import { BackItsmInitialState, IBackItsmState } from '@apps/back/store/itsm/itsm.state';
import * as fromBackItsmActions from '@apps/back/store/itsm/itsm.actions';

export const BackItsmReducer = createReducer(
    BackItsmInitialState,
    on(
        fromRootImpeActions.RootImpersonateSet,
        fromRootImpeActions.RootImpersonateUnset,
        fromAuthProfileActions.AuthProfileApplicationRolesSet,
        fromAuthProfileActions.AuthProfileApplicationRolesReset,
        fromAuthLoginActions.AuthLogout,
        () =>
            BackItsmInitialState
    ),
    on (
        fromBackItsmActions.BackItsmSubEntitiesSucceded,
        (state: IBackItsmState, { subEntities }: {subEntities: string[]}) => ({
            ...state,
            subEntities: [...subEntities]
        })
    ),
    on (
        fromBackItsmActions.BackItsmSubEntityAdded,
        (state: IBackItsmState, { entity }) =>
        {
            const subEntities = state.subEntities;

            return {
                ...state,
                subEntities: subEntities.concat(entity)
            };
        }
    ),
    on (
        fromBackItsmActions.BackItsmSubEntityRemoved,
        (state: IBackItsmState, { entity }) =>
        {
            const subEntities = state.subEntities;

            return {
                ...state,
                subEntities: subEntities.filter(e => e !== entity)
            };
        }
    ),
    on (
        fromBackItsmActions.BackItsmRessourcesRequested,
        (state: IBackItsmState) => ({ ...state, ressources: '' })
    ),
    on (
        fromBackItsmActions.BackItsmRessourcesFailed,
        (state: IBackItsmState) => ({ ...state, ressources: '' })
    ),
    on (
        fromBackItsmActions.BackItsmRessourcesSucceeded,
        (state: IBackItsmState, { ressources }) =>
        {

            return {
                ...state,
                ressources
            };
        }
    )
);
